import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

export const quickActionsAdapter = createEntityAdapter({
  selectId: (quickAction: API.QuickActionWithPosition) =>
    quickAction.action.key,
});

export const catalogAdapter = createEntityAdapter({
  selectId: (catalogItem: API.QuickActionItem) => catalogItem.key,
});

interface QuickActionsState {
  quickActions: ReturnType<typeof quickActionsAdapter.getInitialState>;
  catalog: ReturnType<typeof catalogAdapter.getInitialState>;
}

const initialState: QuickActionsState = {
  quickActions: quickActionsAdapter.getInitialState(),
  catalog: catalogAdapter.getInitialState(),
};

const slice = createSlice({
  name: "quickActions",
  initialState,
  reducers: {
    setMany: (state, action) => {
      quickActionsAdapter.setMany(state.quickActions, action.payload);
    },
    setAll: (state, action) => {
      quickActionsAdapter.setAll(state.quickActions, action.payload);
    },
    setCatalog: (state, action) => {
      catalogAdapter.setAll(state.catalog, action.payload);
    },
  },
});

export const { actions } = slice;

export default {
  quickActions: slice.reducer,
};
